module.exports = __webpack_public_path__ + "static/media/create_sections_fix_supervisor_access.dc0507fd.mov";